import { render, staticRenderFns } from "./SvgLinkedIn.vue?vue&type=template&id=1d1fb919"
import script from "./SvgLinkedIn.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgLinkedIn.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports